import app from "../_app";
import axios from "axios";
const productBlocks = [...document.querySelectorAll('.js-product-block')];
const urlPrefix = 'https://cdn1.api.trustedshops.com/shops/';
const language = document.querySelector('html').getAttribute('lang');

window.onload = function () {
  if (app.viewport.isEqualOrGreaterThan('lg')) {
      productBlocks.map((productBlock) => {
          productBlock.addEventListener('mouseenter', () => {

              if(productBlock.querySelector('.js-slider-trigger[data-next]')){
                  productBlock.querySelector('.js-slider-trigger[data-next]').click();
              }
          });
          productBlock.addEventListener('mouseleave', () => {
              if(productBlock.querySelector('.js-slider-trigger[data-next]')) {
                  productBlock.querySelector('.js-slider-trigger[data-prev]').click();
              }
              productBlock.querySelector('.js-slider-track').style.setProperty('--x', 0);
          });
      });
  }
};

const getStars = rating => {
    let stars = '';

    for(let i = 1; i <= 5; i ++) {

        let star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="207 -707 546 519"><path d="m311-188 45-192-149-129 196-17 77-181 77 181 196 17-149 129 45 192-169-102-169 102Z"/></svg>';

        if(rating < i && Math.round(rating) === i) {
            star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="207 -707 546 519"><path d="M480-635v312l126 77-33-144 111-96-146-13-58-136ZM311-188l45-192-149-129 196-17 77-181 77 181 196 17-149 129 45 192-169-102-169 102Z"/></svg>'

        } else if(i > rating) {
            star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="1 2 20 18"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg>'
        }

        stars += `<i>${star}</i>`;
    }
    return stars;
};
productBlocks.map((productBlock) => {
    let sku = null;
    const productRating = productBlock.querySelector('.js-product-block-reviews');
    if(productBlock) {
        sku = productBlock.dataset.sku;
    }

    const fetchTotals = async () => {

        try {
            let response = await axios.get(urlPrefix + app.trustedShops[language] + '/products/skus/' + app.getEncodedSkus([sku]) + '/productstickersummaries/v1/quality/reviews.json');

            if(response.status === 200 && typeof response.data === 'object') {

                let data = response.data.response.data.product.qualityIndicators.reviewIndicator;

                if(data.totalReviewCount > 0) {

                    const count = data.totalReviewCount;
                    const total = data.overallMark;

                    productRating.querySelector('.js-product-stars-stars').innerHTML = getStars(total);
                    productRating.querySelector('.js-product-stars-count').innerHTML = '(' + count + ')';

                } else {
                    //props.reviewsAdd(props.reviewsKey, false);
                    //reviewsblock.remove();
                }
            } else {
                //productRating.remove();
                //reviewsblock.remove();
            }
        } catch (e) {
            //productRating.remove();
            //reviewsblock.remove();
        }
    };

    if (sku !== null) {
        fetchTotals();
    }

    productBlock.querySelector('.js-wishlist-trigger').addEventListener('click', (e) => {
        e.preventDefault();
    });
});

